<template>
  <v-container id="contratos-jugador" fluid tag="section" class="pa-0 ma-0">
    <base-material-card color="#ac8a2e" icon="mdi-note-multiple" inline class="px-5 py-3" title="Contratos">
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="listcontratos.data"
        :page-count="listcontratos.last_page"
        :page="listcontratos.current_page"
        :server-items-length="listcontratos.total"
        :sort-by="sortby"
        :sort-desc="sortdesc"
        :loading="loading"
        :search.sync="buscar"
        :footer-props="{
          itemsPerPageOptions: itemsPerPage
        }"
        multi-sort
        @click:row="showItem"
        @update:options="getData($event)"
      >
        <template v-if="$can('M_jugadores_edita') && canEdit" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToNewContratoForm('edit', item.id, item.jugador_id, item.contrato_padre_id)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="preguntarCondonacion(item)">
                mdi-cancel
              </v-icon>
            </template>
            <span>Cancelar contrato</span>
          </v-tooltip>
          <v-tooltip v-if="!item.activo_sn" content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>Jugador No Activo</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialog" :max-width="700" :style="{ zIndex: 200 }">
      <v-card>
        <v-toolbar dark color="info" dense flat>
          <v-toolbar-title class="white--text">
            Cancelación de contrato
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          Desea condonar los derechos y obligaciones asociados a este contrato?
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn color="primary darken-1" text @click="cancelarContrato(1)">
            Cancelar contrato y condonar
          </v-btn>
          <v-btn color="primary darken-1" text @click="cancelarContrato(0)">
            Solo cancelar contrato
          </v-btn>
          <v-btn color="grey" text @click="dialog = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: true,
      },
      url: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        sortby: ['valido_desde'],
        sortdesc: [true],
        contratoCancelar: {},
        options_table: {},
        numberOfPages: 0,
        loading: true,
        op: {},
        buscar: '',
        typingTimer: {},
        totalItems: 0,
        itemsPerPage: [5, 10, 15],
        headers: [
          { text: 'Jugador', align: 'start', sortable: true, value: 'fullName' },
          { text: 'Tipo contrato', sortable: true, value: 'tpDescripcion' },
          { text: 'Club', value: 'club' },
          { text: 'Sponsor', value: 'sponsor' },
          { text: 'Desde', value: 'valido_desde' },
          (this.canEdit) ? { text: 'Hasta', value: 'valido_hasta' } : { text: 'Hasta', value: 'valido_hasta', align: 'end' },
          (this.canEdit) ? { text: 'Acciones', value: 'actions', sortable: false, align: 'end' } : {},
        ],
        listcontratos: [],
      }
    },
    watch: {
      buscar () {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => this.readDataFromAPI(1, this.op.sortBy, this.op.sortDesc, this.op.itemsPerPage), 1000)
      },
    },
    methods: {
      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.sortBy, data.sortDesc, data.itemsPerPage)
      },
      readDataFromAPI: async function (page = 1, sortBy, sortDesc, perPage = 5) {
        this.loading = true
        this.$store.dispatch('axiosMod/getData', {
          url: this.url + '?page=' + page + '&search=' + this.buscar +
            '&sortBy=' + sortBy + '&sortDesc=' + sortDesc + '&itemsPerPage=' + perPage,
        }).then(response => {
          this.listcontratos = response
          this.loading = false
        })
      },
      showItem (item) {
        this.goToNewContratoForm('show', item.id, item.jugador_id)
      },
      goToNewContratoForm (modeVal, IdContrato, idJugador, contrato_padre_id = 0) {
        this.$router.push({ name: 'Alta Contrato', params: { mode: modeVal, idJugador: idJugador, idContrato: IdContrato, idcp: contrato_padre_id } })
      },
      preguntarCondonacion (item) {
        this.dialog = true
        this.contratoCancelar = item
      },
      cancelarContrato: async function (condonar = 0, item = this.contratoCancelar) {
        const method = 'post'
        await this.$http({
          method: method,
          url: '/api/contrato_cancelar/' + condonar,
          data: {
            ...item,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Contrato cancelado'] })
          this.$emit('change')
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },
    },
  }
</script>
